import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;

export const isTauri = () => typeof window !== "undefined" && !!window.__TAURI_INTERNALS__;

export const useDesktop = () => {
  const [info, setInfo] = useState(cached);
  useEffect(() => {
    if (cached) return;
    api.desktopInfo().then((d) => { cached = d; setInfo(d); }).catch(() => setInfo({ desktop: false }));
  }, []);
  return info;
};

export const pickFolder = async () => {
  const { open } = await import("@tauri-apps/plugin-dialog");
  return open({ directory: true, multiple: false, title: "Choose the wedding footage folder" });
};
